var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_c('v-container',{staticClass:"py-16"},[_c('v-card-text',[_c('vue-markdown',{staticClass:"markdown",attrs:{"source":_vm.body}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }